export const iconFontAwesomeFoodBeverageWhiskeyGlass = (
	<i className="fa-solid fa-whiskey-glass"></i>
);
